module.exports = __webpack_public_path__ + "static/media/pop-banner-store-preview-mobile.268796fb.webp";